<!--
 * @Description: 职务多条查找带回
 * @Author: PF
 * @Date: 2023-08-29 08:17:33
 * @LastEditors: PF
 * @LastEditTime: 2025-11-07 11:09:42
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">职务</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-row style="height: 100%;">
        <el-col :span="11" style="height: 100%">
          <el-container>
            <el-header class="pl0 pr0">
              <!-- 搜索区域 BEGIN -->
              <el-form class="search" :model="dataGrid.parms" @submit.enter.prevent>
                <el-form-item class="mr10">
                  <el-input placeholder="职务名称" v-model="dataGrid.parms.zwmc" clearable @clear="initLeftList()" @keyup.enter="initLeftList()">
                    <template #suffix>
                      <el-icon class="el-input__icon pointer" @click="initLeftList()">
                        <search />
                      </el-icon>
                    </template>
                  </el-input>
                </el-form-item>
              </el-form>
              <!-- 搜索区域 END -->
            </el-header>
            <el-main style="padding:0">
              <el-table :data="dataGrid.data" border v-loading="dataGrid.loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="leftRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column label="职务代码" prop="zwdm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="职务名称" prop="zwmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
                  <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.zwmc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="职务等级" prop="zwdjmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column width="55" fixed="right" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button link type="primary" @click.stop="leftRowDblclick(scope.row)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="toLeftClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="toRightClick"></span>
          </div>
        </el-col>
        <el-col :span="11" style="height: 100%">
          <el-table :data="rightTableData" border v-loading="dataGrid.loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="rightRowDblclick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column width="55" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-button link type="primary" :disabled="!scope.row.id" @click.stop="rightRowDblclick(scope.row)">
                  <span class="iconfont icon-zuojiantou"></span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="职务代码" prop="zwdm" align="center" show-overflow-tooltip />
            <el-table-column label="职务名称" prop="zwmc" align="center" show-overflow-tooltip >
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.zwmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="职务等级" prop="zwdjmc" align="center" show-overflow-tooltip />
          </el-table>
        </el-col>
      </el-row>
      <template #footer>
        <div class="dialog-footer">
          <el-row style="width: 100%">
            <el-col :span="11">
              <pagination :pagination="dataGrid.pagination" @ReturnData="initLeftList" />
            </el-col>
            <el-col :span="2">
            </el-col>
            <el-col :span="11" style="display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;">共 {{ rightTableData.length }} 条</span>
              <div class="footer_but">
                <el-button type="primary" @click="savestudent()">选择</el-button>
                <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadList, actionPost } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/shujuguanli/gonggongshuju/zhiwu/detail.vue'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])
const openDetail = ref(false)
const row = ref()

const ids = ref([]) // 已选id
const rightTableData = ref([]) // 右侧列表
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选

const savestudent = () => {
  emits('ReturnData', rightTableData.value)
  closeWindow('openDuoTiao', emits, false)
}
// 双击左侧列表
const leftRowDblclick = (row) => {
  leftMultipleSelection.value.push(row)
  toRightClick()
}
// 双击右侧列表
const rightRowDblclick = (row) => {
  rightMultipleSelection.value.push(row)
  toLeftClick()
}
// 左箭头
const toLeftClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      dataGrid.value.data.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    rightMultipleSelection.value = []
  }
}
// 右箭头
const toRightClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      rightTableData.value.push(element)
      dataGrid.value.data.forEach((e, index) => {
        if (e.id === element.id) {
          dataGrid.value.data.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    leftMultipleSelection.value = []
  }
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'zwdm', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async (pageNo, pageSize) => {
  dataGrid.value.parms.jgid = Array.isArray(dataGrid.value.parms.jgid)
    ? dataGrid.value.parms.jgid[dataGrid.value.parms.jgid.length - 1]
    : dataGrid.value.parms.jgid
  dataGrid.value.parms.notInIDs = ids.value

  loadList({
    url: '/api/v2/pdp/zhiwu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

const initRightList = async () => {
  rightTableData.value = []
  dataGrid.value.loading = true
  const o = {
    url: '/api/v2/pdp/zhiwu/list',
    data: { order: 'zwdm', sort: 'asc', inIDs: ids.value }
  }
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    rightTableData.value = res.data // 返回列表
  })
}
watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      ids.value = props.row.ids || []
      initLeftList()
      initRightList()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.filter-item) {
  width: 150px;
}
.search {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-button {
    margin: 0;
  }
}
:deep(.el-radio__label) {
  display: none;
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.e-row {
  height: 100%;
}
</style>
